import type {
  ShortCircuitScenarioResults,
  CalculationScenarioAvailability
} from '../..';

export function getShortCircuitAvailability(
  shortCircuit: ShortCircuitScenarioResults[]
): CalculationScenarioAvailability<'SHORT_CIRCUIT'> {
  return shortCircuit.some(
    shortCircuitScenario => shortCircuitScenario.status === 'Completed'
  )
    ? { type: 'AVAILABLE', calculationType: 'SHORT_CIRCUIT' }
    : { type: 'NOT_AVAILABLE' };
}
